export default function Button({
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = false,
  children,
  className = '',
  ...props
}) {
  const baseStyles = 'font-semibold rounded transition-all duration-150 flex items-center justify-center gap-2'

  const variantStyles = {
    primary: 'bg-accent text-white hover:bg-accent-hover active:bg-accent-darker disabled:opacity-50',
    secondary: 'bg-transparent text-text-primary border border-outline hover:bg-surface-bright active:border-accent disabled:opacity-50',
    danger: 'bg-status-urgent text-white hover:opacity-90 active:opacity-75 disabled:opacity-50',
  }

  const sizeStyles = {
    sm: 'px-3 py-2 text-label-sm min-h-10',
    md: 'px-6 py-3 text-label-md min-h-12',
    lg: 'px-8 py-4 text-body-md min-h-14 w-full',
  }

  const computedClassName = `
    ${baseStyles}
    ${variantStyles[variant] || variantStyles.primary}
    ${sizeStyles[size] || sizeStyles.md}
    ${fullWidth ? 'w-full' : ''}
    ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
    ${className}
  `

  return (
    <button
      className={computedClassName}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}
